__turbopack_context__.v({
  "subtitle": "SloeFW_subtitle",
  "title-divider": "SloeFW_title-divider",
});
